/**
 * 章节编辑数据服务（Axios 版本）
 * 替换原有的 WebSocket 实现
 */
import { ref } from 'vue';
import { getOneNovel, getChapterContent, updateChapter } from './api';

export const novelAndPutNovelWebSocket = (currentId, novel_id) => {
    const connected = ref(true); // Axios 总是"连接"状态
    const chapterId = ref(currentId);
    const novelId = ref(novel_id);
    const novels = ref({});
    const chapter_content = ref({});
    const loading = ref(false);
    const errorItNovel = ref(null);
    const error = ref(null);

    // 请求小说详情和章节内容
    const fetchNovelsChapter = async () => {
        loading.value = true;
        errorItNovel.value = null;
        error.value = null;

        try {
            // 并行请求小说详情和章节内容
            const [novelResult, contentResult] = await Promise.all([
                getOneNovel(novelId.value),
                getChapterContent(novelId.value, chapterId.value)
            ]);

            // Result 结构：{ code: 0, msg: "success", data: [...] }
            if (novelResult.code === 0) {
                novels.value = novelResult.data;
                console.log('获取小说信息成功');
            } else {
                errorItNovel.value = novelResult.msg || '获取小说信息失败';
            }

            if (contentResult.code === 0) {
                chapter_content.value = contentResult.data;
                console.log('获取章节内容成功');
            } else {
                error.value = contentResult.msg || '获取章节内容失败';
            }
        } catch (err) {
            console.error('请求数据失败:', err);
            errorItNovel.value = err.message || '请求数据失败';
            error.value = err.message || '请求数据失败';
        } finally {
            loading.value = false;
        }
    };

    // 更新章节
    const updateNovelsChapter = async (updateChapterData, updateContentData) => {
        loading.value = true;
        errorItNovel.value = null;
        error.value = null;

        try {
            const result = await updateChapter(updateChapterData, updateContentData);
            if (result.code === 0) {
                console.log('更新章节成功');
            } else {
                errorItNovel.value = result.msg || '更新章节失败';
            }
        } catch (err) {
            console.error('更新章节失败:', err);
            errorItNovel.value = err.message || '更新章节失败';
        } finally {
            loading.value = false;
        }
    };

    return {
        connected,
        novels,
        chapter_content,
        loading,
        errorItNovel,
        error,
        fetchNovelsChapter,
        updateNovelsChapter,
    };
};
